var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.23291,
    y: 3.10522,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_21946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5662 26.4386L23.2329 23.1052M23.2329 23.1052L19.8995 26.4386M23.2329 23.1052V30.6052M30.2245 28.4302C31.0373 27.9871 31.6794 27.286 32.0494 26.4374C32.4195 25.5889 32.4964 24.6413 32.268 23.7441C32.0397 22.847 31.5191 22.0515 30.7884 21.4831C30.0578 20.9147 29.1586 20.6058 28.2329 20.6052H27.1829C26.9306 19.6296 26.4605 18.7238 25.8078 17.9561C25.1552 17.1883 24.3369 16.5784 23.4146 16.1724C22.4923 15.7664 21.49 15.5747 20.483 15.6118C19.4759 15.6489 18.4904 15.9138 17.6005 16.3866C16.7106 16.8594 15.9395 17.5278 15.3451 18.3415C14.7507 19.1553 14.3485 20.0932 14.1687 21.0847C13.9889 22.0763 14.0363 23.0957 14.3072 24.0663C14.5781 25.0369 15.0656 25.9334 15.7329 26.6886",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23291,
    y: 3.10522,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_21946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.2329 13.1052)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.df82ca3797306df680cb3f4639549319.svg";
export { ForwardRef as ReactComponent };